import { CustomerUser } from '../services/CustomerUserService';

// Permission types
export type Permission = 
  | 'view_opportunities'
  | 'manage_opportunities' 
  | 'manage_users'
  | 'role_management';

// Permission checking utility
export const hasPermission = (user: CustomerUser | null, permission: Permission): boolean => {
  console.log('=== DEBUG: hasPermission function ===');
  console.log('user:', user);
  console.log('permission:', permission);
  console.log('!user:', !user);
  console.log('!user.role:', !user?.role);
  
  if (!user || !user.role) {
    console.log('User or role is null/undefined, returning false');
    console.log('=== END DEBUG ===');
    return false;
  }

  const result = user.role.permissions[permission] === true;
  console.log('user.role.permissions[permission]:', user.role.permissions[permission]);
  console.log('Final result:', result);
  console.log('=== END DEBUG ===');
  return result;
};

// Check multiple permissions (all must be true)
export const hasAllPermissions = (user: CustomerUser | null, permissions: Permission[]): boolean => {
  return permissions.every(permission => hasPermission(user, permission));
};

// Check multiple permissions (any can be true)
export const hasAnyPermission = (user: CustomerUser | null, permissions: Permission[]): boolean => {
  return permissions.some(permission => hasPermission(user, permission));
};

// Get user's role name
export const getUserRoleName = (user: CustomerUser | null): string => {
  return user?.role?.name || 'No Role';
};

// Check if user is readonly (only view_opportunities permission)
export const isReadOnlyUser = (user: CustomerUser | null): boolean => {
  if (!user || !user.role) {
    return false;
  }

  const permissions = user.role.permissions;
  return permissions.view_opportunities === true && 
         permissions.manage_opportunities === false &&
         permissions.manage_users === false &&
         permissions.role_management === false;
};

// Check if user can manage opportunities
export const canManageOpportunities = (user: CustomerUser | null): boolean => {
  console.log('=== DEBUG: canManageOpportunities function ===');
  console.log('user:', user);
  console.log('user?.role:', user?.role);
  console.log('user?.role?.permissions:', user?.role?.permissions);
  console.log('user?.role?.permissions?.manage_opportunities:', user?.role?.permissions?.manage_opportunities);
  const result = hasPermission(user, 'manage_opportunities');
  console.log('Final result:', result);
  console.log('=== END DEBUG ===');
  return result;
};

// Check if user can manage users
export const canManageUsers = (user: CustomerUser | null): boolean => {
  return hasPermission(user, 'manage_users');
};

// Check if user can manage roles
export const canManageRoles = (user: CustomerUser | null): boolean => {
  return hasPermission(user, 'role_management');
};

// Check if user can view opportunities
export const canViewOpportunities = (user: CustomerUser | null): boolean => {
  return hasPermission(user, 'view_opportunities');
}; 